<template>
  <!-- Student Info / Reading / Math / Drafted Present Levels -->
  <nav aria-label="Breadcrumb">
    <ol class="breadcrumb">
      <li v-if="uuid">
        <span
          v-if="isActiveBreadcrumb('PresentLevelsExistingWizard')"
          aria-current="page"
          tabindex="0"
        >
          Student Info
        </span>
        <router-link v-else :to="{name: 'PresentLevelsExistingWizard', params: { uuid: uuid }}">
          Student Info
        </router-link>
      </li>
      <li :key="subject.value" v-for="subject in sortedAreasOfNeed">
        <span
          v-if="isActiveBreadcrumb('PresentlevelsSubjectResults', subject.value)"
          aria-current="page"
          tabindex="0"
        >
          {{ subject.label }}
        </span>
        <router-link
          v-else
          @click.native="handleClick(subject.value)"
          :to="{name: 'PresentlevelsSubjectResults', params: { uuid: uuid, subject: subject.value}}"
        >
          {{ subject.label }}
        </router-link>
      </li>
      <li v-if="uuid">
        <span
          v-if="isActiveBreadcrumb('PresentlevelsConclusion')"
          aria-current="page"
          tabindex="0"
        >
          Drafted Present Levels
        </span>
        <router-link
          v-else
          :to="{name: 'PresentlevelsConclusion', params: { uuid: uuid}}"
        >
          Drafted Present Levels
        </router-link>
      </li>
    </ol>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import { getAreasOfNeed } from '@/api/presentlevels'
export default {
  name: 'PresentlevelsBreadcrumbs',
  props: {
    uuid: {
      required: true,
      type: String
    },
    availableStages: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    ...mapGetters('visibility',['selVisibility']),
    sortedAreasOfNeed() {
      return getAreasOfNeed({selBlocked: !this.selVisibility}).filter(subject => this.availableStages.includes(subject.value))
    }
  },
  methods: {
    handleClick(subject) {
      this.$sendEvent('Clicked Subject in Present Levels Breadcrumb', {
        plw_area_of_need: subject
      })
    },
    isActiveBreadcrumb(breadcrumb, subject = '') {
      if (this.$route.params.subject && subject) {
        return this.$route.params.subject === subject
      }
      const conclusionRoutes = ['PresentlevelsConclusion', 'PresentlevelsConclusionAssessments', 'PresentlevelsConclusionGoalsStrategies']
      if (breadcrumb === 'PresentlevelsConclusion') {
        return conclusionRoutes.includes(this.$route.name)
      }
      return this.$route.name === breadcrumb
    }
  }
}
</script>

<style scoped lang="scss">
.router-link-exact-active {
  font-weight: bold;
}
</style>
